import { posStorage } from "./storage";

export type PosAdminPageState = {
  orders?: {
    location?: string;
    status?: string;
    currentPage?: number;
    itemsPerPage?: number;
    searchQuery?: string;
    dateRange?: { from: string; to: string };
    priceRange?: { min: string; max: string };
  };
  kitchen?: {
    location?: string;
  };
  products?: {
    availability?: string;
    category?: string;
    subcategory?: string;
    dishType?: string;
    locations?: string;
    currentPage?: number;
    itemsPerPage?: number;
    searchQuery?: string;
    dateRange?: { from: string; to: string };
    priceRange?: { min: string; max: string };
  };
  menuTypes?: {
    status?: string;
    timeRange?: { from: string; to: string };
    searchQuery?: string;
    currentPage?: number;
    itemsPerPage?: number;
    dateRange?: { from: string; to: string };
  };
  users?: {
    role?: string;
    dateRange?: { from: string; to: string };
    searchQuery?: string;
    currentPage?: number;
    itemsPerPage?: number;
  };
  customDrinks?: {
    type?: string;
    status?: boolean;
    currentPage?: number;
    itemsPerPage?: number;
    searchQuery?: string;
    priceRange?: { min: string; max: string };
  };
  locations?: {
    searchQuery?: string;
    currentPage?: number;
    itemsPerPage?: number;
    dateRange?: { from: string; to: string };
    active?: boolean;
  };
  subcategories?: {
    searchQuery?: string;
    currentPage?: number;
    itemsPerPage?: number;
    dateRange?: { from: string; to: string };
    active?: boolean;
  };
  modifierGroups?: {
    status?: string;
    searchQuery?: string;
    currentPage?: number;
    itemsPerPage?: number;
    dateRange?: { from: string; to: string };
  };
  [key: `modifiers-${string}`]:
    | {
        status?: string;
        searchQuery?: string;
        currentPage?: number;
        itemsPerPage?: number;
        dateRange?: { from: string; to: string };
      }
    | undefined;
  categories?: {
    searchQuery?: string;
    currentPage?: number;
    itemsPerPage?: number;
    dateRange?: { from: string; to: string };
    active?: boolean;
  };
  ui?: {
    isSidebarOpen?: boolean;
    sidebarWidth?: string;
  };
  reports?: {
    activeTab?: string;
    dateRange?: { from: string; to: string };
  };
  "activity-logs"?: {
    dateRange?: { from: string; to: string };
    actionFilter?: string;
    entityTypeFilter?: string;
  };
  discounts?: {
    status?: string;
    activationType?: string;
    searchQuery?: string;
    currentPage?: number;
    itemsPerPage?: number;
    dateRange?: { from: string; to: string };
  };
  transactions?: {
    typeFilter?: string;
    currentPage?: number;
    itemsPerPage?: number;
    searchQuery?: string;
    dateRange?: { from: string; to: string };
  };
  taxSettings?: {
    status?: string;
    searchQuery?: string;
    currentPage?: number;
    itemsPerPage?: number;
    dateRange?: { from: string; to: string };
  };
  entryPassTemplates?: {
    searchQuery?: string;
    currentPage?: number;
    itemsPerPage?: number;
  };
  membershipTemplates?: {
    searchQuery?: string;
    currentPage?: number;
    itemsPerPage?: number;
  };
  waivers?: {
    searchQuery?: string;
    currentPage?: number;
    itemsPerPage?: number;
  };
};

const APP_KEY = "sech_pos_admin";

export function loadPosAdminStorage(): PosAdminPageState {
  return posStorage.get<PosAdminPageState>(APP_KEY, {});
}

export function savePosAdminStorage(state: PosAdminPageState) {
  posStorage.set<PosAdminPageState>(APP_KEY, state);
}

export function getPosStorageByKey<PageState>(
  pageKey: keyof PosAdminPageState,
  defaultState: PageState
): PageState {
  const appState = loadPosAdminStorage();
  const pageState = (appState[pageKey] || {}) as PageState;
  return { ...defaultState, ...pageState };
}

export function updatePosStorageByKey<PageState>(
  pageKey: keyof PosAdminPageState,
  partial: Partial<PageState>
) {
  const appState = loadPosAdminStorage();
  const prevPageState = (appState[pageKey] || {}) as PageState;

  const nextPageState = {
    ...prevPageState,
    ...partial,
  };

  const nextAppState: PosAdminPageState = {
    ...appState,
    [pageKey]: nextPageState,
  };

  savePosAdminStorage(nextAppState);
}
